var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#FCFCFC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#EFEFEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 18.7368C22.9651 18.7368 25.3686 16.3333 25.3686 13.3684C25.3686 10.4035 22.9651 8 20.0002 8C17.0354 8 14.6318 10.4035 14.6318 13.3684C14.6318 16.3333 17.0354 18.7368 20.0002 18.7368Z",
    fill: "#1A1D1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20C14.7679 20 10.5264 24.2416 10.5264 29.4737C10.5264 30.8689 11.6575 32 13.0527 32H26.9474C28.3427 32 29.4738 30.8689 29.4738 29.4737C29.4737 24.2416 25.2322 20 20 20Z",
    fill: "#1A1D1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerIcon);
export default __webpack_public_path__ + "static/media/Player_Icon.e5f6c7f6d7dba31631715ed8fa029c8f.svg";
export { ForwardRef as ReactComponent };